<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({
					name: 'SubBotDetail',
					params: { botId: item.bot._id, subBotId: item._id }
				})
			},
			items: [
				{
					header: 'Nom',
					value: (item) => item.name,
					sort: 'name',
					filter: {
						 name: 'name'
					 }
				},
				{
					header: 'Clef',
					value: (item) => item.key,
					sort: 'key',
					filter: {
						name: 'key'
					}
				},
				{
					header: 'Nombre envoyé',
					value: (item) => item.totalSend ? item.totalSend : 'non renseigné',
					sort: 'totalSend',
					filter: false
				}
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/subBots/subBot.list.vue